import { useState } from 'react';
import { Link } from 'react-router-dom';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <div className="w-full px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/eeca736fc8054caf90a8ed02ed251b58/88843bf402c6fc53b07c691934966244.png" 
              alt="altta talent studio" 
              className="h-16"
            />
          </Link>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-[#3a3a3a] w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>

          <div className="hidden lg:flex items-center gap-12">
            <Link 
              to="/" 
              className="text-[#3a3a3a] hover:text-[#ffb7b4] transition-colors duration-300 text-base cursor-pointer"
            >
              Inicio
            </Link>
            <Link 
              to="/contacto" 
              className="text-[#3a3a3a] hover:text-[#ffb7b4] transition-colors duration-300 text-base cursor-pointer"
            >
              Contacto
            </Link>
          </div>
        </div>

        {isMenuOpen && (
          <div className="lg:hidden py-6 border-t border-[#3a3a3a]/10">
            <div className="flex flex-col gap-6">
              <Link 
                to="/" 
                onClick={() => setIsMenuOpen(false)}
                className="text-[#3a3a3a] hover:text-[#ffb7b4] transition-colors duration-300 text-base cursor-pointer"
              >
                Inicio
              </Link>
              <Link 
                to="/contacto" 
                onClick={() => setIsMenuOpen(false)}
                className="text-[#3a3a3a] hover:text-[#ffb7b4] transition-colors duration-300 text-base cursor-pointer"
              >
                Contacto
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
